import React, { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import Button from './Button';
import styles from './DetailPageHeader.module.css';

interface DetailPageHeaderProps {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  metadata?: ReactNode;
  backLabel: string;
  onBack: () => void;
  actions?: ReactNode;
}

export const DetailPageHeader: React.FC<DetailPageHeaderProps> = ({
  icon,
  title,
  subtitle,
  metadata,
  backLabel,
  onBack,
  actions
}) => {
  return (
    <div className={styles.detailHeader}>
      <div className={styles.detailHeaderNav}>
        <Button variant="ghost" onClick={onBack}>
          <ArrowLeft size={16} />
          {backLabel}
        </Button>
      </div>

      <div className={styles.detailHeaderContent}>
        <div className={styles.detailTitleSection}>
          <h1 className={styles.detailTitle}>
            {icon && <span className={styles.detailTitleIcon}>{icon}</span>}
            {title}
          </h1>
          {subtitle && <div className={styles.detailSubtitle}>{subtitle}</div>}
          {metadata && <div className={styles.detailMeta}>{metadata}</div>}
        </div>

        {actions && <div className={styles.detailActions}>{actions}</div>}
      </div>
    </div>
  );
};

export default DetailPageHeader;
